import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from 'components/ui/Button';
import Typography from 'components/ui/Typography';
import ROUTES from 'routes';
import { layout } from 'styles';

const Error404: React.FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <div className={`${layout.flexColCenter} ${layout.gap2}`}>
                <Typography style="HeadLargeBold" align="center">
                    {t('ErrorInfo.Error401Label')}
                </Typography>
                <Typography style="BodyLargeNormal" align="center">
                    {t('ErrorInfo.AdviceError401')}
                </Typography>
            </div>
            <Link to={ROUTES.HOME}>
                <Button withPadding>{t('Common.BackToHome')}</Button>
            </Link>
        </>
    );
};

export default Error404;
